export const getEmailSecretOverride = (): string | null => {
    return localStorage.getItem('EMAIL_INVITE_SECRET_OVERRIDE')
}
